module.exports = __webpack_public_path__ + "img/10.57227763.jpg";